<style lang="less" scoped>
    *{
        margin: 0;
        padding: 0;
        box-sizing: border-box;
    }
    li{
        list-style: none;
    }
    .albumBox{
        text-align: left;
        width: 780px;
        background-color: #fff;
        border-radius: 8px;
        position: fixed;
        top: 50%;
        transform: translateY(-50%);
        z-index: 3;
        left: 50%;
        margin-left: -390px;
        padding: 18px 40px;
        .albumInfo{
            margin-top: 16px;
            >ul{
                display: flex;
                justify-content: space-between;
                flex-wrap: wrap;
                >li{
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    margin-bottom: 16px;
                    >span{
                        display: inline-block;
                        min-width: 56px;
                        color: #707070;
                        text-align-last: justify;
                    }
                    >div{
                        width: 240px;
                        height: 30px;
                        border-radius: 4px;
                        border: 1px solid #B7B7B7;
                        margin-left: 33px;
                        display: flex;
                        align-items: center;
                        input{
                            &::-webkit-input-placeholder{
                                color: #b7b7b7;
                            }
                            outline: none;
                            border: none;
                            text-indent: 8px;
                            color: #333;
                            width: 90%;
                        }
                    }
                }
            }
            .chooseColor{
                .carHead{
                    display: flex;
                    align-items: center;
                    >span{
                        display: inline-block;
                        min-width: 56px;
                        text-align-last: justify;
                    }
                    >div{
                        position: relative;
                        margin-left: 33px;
                        >p{
                            cursor: pointer;
                            color: #F36800;
                        }
                    }
                }
                .colorCarBox{
                    padding: 15px 0 0 89px;
                    width: 100%;
                    max-height: 200px;
                    overflow-y: auto;
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        li{
                            position: relative;
                            width: 76px;
                            margin: 0 26px 20px 0;
                            &:nth-of-type(6n){
                                margin: 0 0 20px 0;
                            }
                            .edge_imgBox{
                                width: 76px;
                                height: 76px;
                                border-radius: 4px;
                                border: 1px solid #707070;
                                >img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            p{
                                text-align: center;
                            }
                            .chacha{
                                position: absolute;
                                right: -5px;
                                top: -5px;
                                display: inline-block;
                                width: 16px;
                                height: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background-color: #757575;
                                opacity: 0.8;
                                border-radius: 50%;
                                cursor: pointer;
                                img{
                                    width: 10px;
                                    height: 10px;
                                }
                            }
                        }
                    }
                }
            }
            .chooseColorCar{
                font-size: 14px;
                margin-top: 10px;
                .carHead{
                    display: flex;
                    align-items: center;
                    >span{
                        display: inline-block;
                        min-width: 56px;
                        text-align-last: justify;
                    }
                    >div{
                        position: relative;
                        margin-left: 33px;
                        >input{
                            opacity: 0;
                        }
                        >p{
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: -1;
                            cursor: pointer;
                            color: #6376F7;
                        }
                    }
                }
                .colorCarBox{
                    padding: 15px 0 0 89px;
                    width: 100%;
                    // height: 200px;
                    overflow-y: auto;
                    ul{
                        display: flex;
                        flex-wrap: wrap;
                        li{
                            position: relative;
                            width: 76px;
                            margin: 0 26px 20px 0;
                            &:nth-of-type(6n){
                                margin: 0 0 20px 0;
                            }
                            .edgeGoods_imgBox{
                                width: 76px;
                                height: 76px;
                                border-radius: 4px;
                                border: 1px solid #707070;
                                >img{
                                    width: 100%;
                                    height: 100%;
                                }
                            }
                            .chacha{
                                position: absolute;
                                right: -5px;
                                top: -5px;
                                display: inline-block;
                                width: 16px;
                                height: 16px;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                background-color: #757575;
                                opacity: 0.8;
                                border-radius: 50%;
                                cursor: pointer;
                                img{
                                    width: 10px;
                                    height: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .footerBtn{
            display: flex;
            justify-content: flex-end;
            margin-top: 16px;
            >div{
                cursor: pointer;
                width: 80px;
                height: 32px;
                line-height: 32px;
                text-align: center;
                font-size: 14px;
                border-radius: 6px;
            }
            .cancel:hover{
                border-radius: 14px;
                background-color: #F5F5F5;
            }
            .sure{
                background: linear-gradient(131deg, #87B3FF 0%, #6376F7 100%);
                color: #fff;
                margin-right: 10px;
                &:hover{
                    background: #6376F7;
                }
            }
        }
        .edgeUpMeng{
            position: fixed;
            left: 0;
            top: 0;
            z-index: 3;
            width: 100%;
            height: 100%;
            background: rgba(51, 51, 51, 0.51);
        }
    }
    .chooseColorMeng{
        position: fixed;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 3;
        background: rgba(51, 51, 51, 0.51);
    }
</style>
<template>
    <div>
        <div class="editMeng" v-if="mengShow"></div>
        <div class="albumBox">
            <p class="title" style="color:#999;">{{info?'编辑':'新建'}}产品</p>
            <div class="albumInfo">
                <ul>
                    <li>
                        <span>名称</span><div><input type="text" placeholder="请输入名称（必填）"  v-model="formData.name"></div>
                    </li>
                    <li>
                        <span>材质</span><div><input type="text" placeholder="请输入材质（必填）"  v-model="formData.data.material"></div>
                    </li>
                    <li>
                        <span>规格</span><div><input type="text" placeholder="请输入规格（必填）"  v-model="formData.data.spec"></div>
                    </li>
                    <li>
                        <span>厚度</span><div><input type="number" placeholder="请输入厚度（必填）"  v-model="formData.data.thick"></div>
                    </li>
                    <li>
                        <span>宽度</span><div><input type="number" placeholder="请输入宽度（必填）"  v-model="formData.data.width"></div>
                    </li>
                    <li>
                        <span>会员价</span><div><input type="number" placeholder="请设置会员价"  v-model="formData.vip_price"></div>
                    </li>
                    <li>
                        <span>零售价</span><div><input type="number" placeholder="请设置零售价"  v-model="formData.price"></div>
                    </li>
                    <li>
                        <span>采购价</span><div><input type="number" placeholder="请设置采购价"  v-model="formData.base_price"></div>
                    </li>
                    <li>
                        <span>分仓价</span><div><input type="number" placeholder="请设置分仓价"  v-model="formData.org_price"></div>
                    </li>
                    <li>
                        <span>备注</span><div><input type="text" placeholder="请输入备注" v-model="formData.remark" :title='formData.content'></div>
                    </li>
                    <li>
                        <span>详情</span><div><input type="text" placeholder="请输入详情" v-model="formData.data.content" :title='formData.content'></div>
                    </li>
                </ul>
                <div class="chooseColor">
                    <div class="carHead"><span>色卡</span><div v-if="!info"><p @click="chooseColor" style="color:#6376F7;">选择色卡<i class="el-icon-arrow-right"></i></p></div></div>
                    <div class="colorCarBox">
                        <ul>
                            <li v-for="item in colorList" :key='item.id'>
                                <div class="edge_imgBox"><img :src="item.picture[0]" alt=""></div>
                                <p>{{item.name}}</p>
                                <!-- <span class="chacha" @click="deleteImg(index)"><img src="../../../../assets/icon_chacha_n.png" alt=""></span> -->
                            </li>                       
                        </ul>
                    </div>
                </div>
                <div class="chooseColorCar">
                    <div class="carHead"><span>图片</span><div><input @change="UpImg" type="file" multiple="multiple" accept="image/*"><p>上传图片<i class="el-icon-arrow-right"></i></p></div></div>
                    <div class="colorCarBox">
                        <ul>
                            <li v-for="(item,index) in formData.picture" :key='index'>
                                <div class="edgeGoods_imgBox"><img :src="item.url?item.url:item" alt=""></div>
                                <span class="chacha" @click="deleteImg(index)"><img src="../../../../assets/icon_chacha_n.png" alt=""></span>
                            </li>                       
                        </ul>
                    </div>
                </div>
            </div>
            <div class="footerBtn">
                <div class="sure" @click="hidealbumBox('sure')">确认</div>
                <div class="cancel" @click="hidealbumBox('cancel')">取消</div>
            </div>
        </div>
        <ColorBox v-show="boxShow" @chooseColor="chooseColor" :color_ids=[]></ColorBox>
        <div class="chooseColorMeng" v-show="boxShow" @click="boxShow = false"></div>
    </div>
    
</template>
<script>
import  upload  from '../../../../util/uploadOss'
import ColorBox from '../../ChooseColorBox'
export default {
    components:{
        ColorBox
    },
    props:['info'],
    data(){
        return{
            no_img:require('../../../../assets/no_img.png'),
            // typeOption:['连接件','铰链','螺丝','拉手','其他'],
            mengShow:true,
            boxShow:false,
            formData:{
                brand_id:0,
                name:'',
                vip_price:'',
                base_price:'',
                org_price:'',
                price:'',
                type:'edge',
                remark:'',
                picture:[],
                s_color_id:[],
                data:{
                    thick:'',     
                    content:'',  //详情
                    material:'', //材质
                    spec:'',
                    width:''
                }
            },
            colorList:[]
        }
    },
    methods:{
        chooseColor(colorList){
            this.boxShow = !this.boxShow
            if(Array.isArray(colorList)){
                this.colorList = colorList
                this.formData.s_color_id = []
                colorList.forEach(item => {
                    this.formData.s_color_id.push(item.id)
                })
            }
        },
        changeClass(e){
            this.formData.sub_type = e.target.value
        },
        UpImg(e){
            let file = e.target.files
            for(let i in file){
                if(!isNaN(Number(i))){
                    upload.uploadVideoToOss(file[i],res=>{
                        let imgInfo = {
                            name:'edge',
                            url:res
                        }
                        this.formData.picture.push(imgInfo)
                    },()=>{})
                }
            }
        },
        hidealbumBox(type){
            if(type == 'sure'){
                let formData = this.formData
                if(!formData.name){
                    this.$message.error('请填写名称')
                    return
                }
                if(!formData.data.material){
                    this.$message.error('请填写材质')
                    return
                }
                if(!formData.data.spec){
                    this.$message.error('请填写规格')
                    return
                }
                if(!formData.data.thick){
                    this.$message.error('请填写厚度')
                    return
                }
                if(!formData.data.width){
                    this.$message.error('请填写宽度')
                    return
                }
                if(!formData.vip_price){
                    formData.vip_price = 0
                    // this.$message.error('请填写会员价')
                    // return
                }
                if(!formData.price){
                    formData.price = 0
                    // this.$message.error('请填写零售价')
                    // return
                }
                if(formData.s_color_id.length == 0){
                    this.$message.error('请选择色卡')
                    return
                }
                if(!formData.base_price){
                    // this.$message.error('请填写会员价')
                    // return
                    formData.base_price = 0
                }
                if(!formData.org_price){
                    // this.$message.error('请填写会员价')
                    // return
                    formData.org_price = 0
                }
                // if(!this.formData.picture.length){
                //     this.$message.error('请上传商品图片')
                //     return
                // }
                if(!this.formData.picture.length){
                    this.formData.picture = [
                        {
                            name:'default',
                            url:'https://eggrj.oss-cn-hangzhou.aliyuncs.com/cloudPictures/11_11/HsAyM7BaKs.png'
                        }
                    ]
                }
                this.formData.supplier_id = this.supplier_id
                this.formData.uid = this.userInfo.id
                if(this.info){
                    this.formData.id = this.info.id
                }
                // this.axios.post('https://ggtools.thinkerx.com/erp/add_other_commodity',this.formData).then(res => {
                //     console.log(res)
                //     if(res.data.status == 1){
                //         console.log(1111)
                //         this.$message.success(this.info?'编辑成功':'添加成功')
                //         this.$emit('getList')
                //     }
                //     this.$emit('hideEditBox')
                // })
                this.$post("/py/erp/add_other_commodity",this.formData,res => {
                     if(res.status == 1){
                        console.log(1111)
                        this.$message.success(this.info?'编辑成功':'添加成功')
                        this.$emit('getList')
                    }
                    this.$emit('hideEditBox')
                })
            } else {
                this.$emit('hideEditBox')
            }
        },
        deleteImg(deIndex){
            this.formData.picture.splice(deIndex,1)
        }
    },
    mounted(){
        let info = JSON.parse(JSON.stringify(this.info))
        // let info = this.info
        if(info){
            this.formData.name = info.name
            this.formData.price = info.ret_price
            this.formData.vip_price = info.price
            this.formData.org_price = info.adj_price
            this.formData.base_price = info.pur_price
            this.formData.remark = info.remarks
            this.formData.picture = info.pictures
            this.formData.data.width = String(info.width)
            this.formData.data.content = info.content
            this.formData.data.spec = info.spec
            this.formData.data.material = info.type
            this.formData.data.thick = String(info.thick)
            this.formData.s_color_id = [info.color_id]
            this.colorList = [
                {
                    name:info.color,
                    picture:[info.pictures[0].url]
                }
            ]
        }
    },
    computed:{
        supplier_id(){
          if(this.$store.state.supplierInfo){
            return this.$store.state.supplierInfo.id
          }else{
            return 0
          }
        },
        userInfo(){
          return this.$store.state.userInfo
        },
    }
}
</script>